import { graphql } from '../../__generated__';

export const REWARD_BALANCE = graphql(`
  query RewardBalance {
    rewardBalance {
      availableCredit
    }
  }
`);
